import { defineSlotRecipe } from '@chakra-ui/react';

export const accordionMenuItemSlotRecipe = defineSlotRecipe({
    slots: ['icon', 'button'],
    base: {
        icon: {
            color: 'secondary.solid',
        },
        button: {
            py: 0,
            pl: 7,
            pr: 4,
            justifyContent: 'space-between',
            color: 'secondary.solid',
            borderLeft: '0.25rem solid',
            borderLeftColor: 'transparent',
            _hover: { bg: 'white' },
            _expanded: {
                bg: 'secondary.50',
                borderLeftColor: 'secondary.300',
                fontWeight: 'bold',
            },
        },
    },
});
